function getDisplayName(WrappedComponent) {
  if (WrappedComponent.type && WrappedComponent.type.name) {
    // this is a fix for memoized components
    return WrappedComponent.type.name;
  }
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

export { getDisplayName };
